// Where to go right after signing in (US 9436).
// The page the user was sent away from when their session ended, unless that was Home, an error page
// or a sign-in page; otherwise Administration for super admins and Home for everyone else.

const NOT_A_RETURN_PAGE = ['/403', '/404', '/login', '/token', '/register', '/password', '/email'];

export function landingPage(historyPage, isAdmin) {
  let page = historyPage || '';
  let path = page.split(/[?#]/)[0];
  let skip = path === '/' || NOT_A_RETURN_PAGE.some(prefix => path === prefix || path.indexOf(prefix + '/') === 0);

  if (page && !skip) {
    return page;
  }

  return isAdmin ? '/administration' : '/';
}
